export default __webpack_public_path__ + "static/media/logo-snm.3dc1e476.svg";